export default __webpack_public_path__ + "static/media/Gateway.30c31784.jpg";